/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Wry_Coral_Dove_BiteInputs */

const en_wry_coral_dove_bite = /** @type {(inputs: Wry_Coral_Dove_BiteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed updates: ${i?.count}`)
};

const de_wry_coral_dove_bite = /** @type {(inputs: Wry_Coral_Dove_BiteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehlgeschlagene Änderungen: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Failed updates: {count}" |
*
* @param {Wry_Coral_Dove_BiteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wry_coral_dove_bite = /** @type {((inputs: Wry_Coral_Dove_BiteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wry_Coral_Dove_BiteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wry_coral_dove_bite(inputs)
	return de_wry_coral_dove_bite(inputs)
});